import { Button, createStyles, Grid, makeStyles, Theme, TextField } from '@material-ui/core';
import { ErrorAPI } from 'api/Associado/methods';
import sicrediStyles from 'assets/styles/default.scss';
import { AxiosError } from 'axios';
import { IPauta } from 'components/AssembleiaPautas/AssembleiaPautas';
import { SyncIcon } from 'components/Icons';
import { AssembleiaPautaStatus } from 'enuns/AssembleiaPautaStatus';
import moment, { Moment } from 'moment';
import React, { useCallback, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { assembleiasAssessorActionsAlterarSituacaoPautaPorData, assembleiasAssessorActionsLoadPautas } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { inputDateMask, inputTimeMask, isAValidDate, localeDateToISO, isAValidTime } from 'utils/DateUtils';
import ErrorHandler from 'utils/ErrorHandler';
import { IModalProps } from '../../store/modules/ModalsReducer';
import { IReducer } from '../../store/Reducer';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';

export interface IAbrirVotacaoPautaModalGenericProps extends IGenericModalProps {
  key: string,
  pauta: IPauta
}

export interface IAbrirVotacaoPautaModal extends IModalProps {
  genericProps?: IAbrirVotacaoPautaModalGenericProps,
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tempoInput: {
      marginTop: '10px',
      width: '100% !important'
    },
    selectRoot: {
      marginTop: '10px',
      width: '100% !important',
    },
    dropdownIcon: {
      fontSize: 16,
      color: sicrediStyles.primarySicredi,
    },
    actionsContent: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    inputTime: {
      maxWidth: '200px'
    }
  }),
);

// const INITIAL_STATUS = '00:05:00';
const ASSEMBLEIA_EDIT_MODAL_DATA_FIELD_ID = 'data';
const ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID = 'horario';
let defaultValues: any = {};
defaultValues[ASSEMBLEIA_EDIT_MODAL_DATA_FIELD_ID] = '';
defaultValues[ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID] = '';

export default ({ genericProps }: IAbrirVotacaoPautaModal) => {
  const { t } = useTranslation();
  const classes = useStyles();
  // const [tempo, setTempo] = useState<IInputTimeObject>();
  const [salvando, setSalvando] = useState<boolean>(false);
  const currentEvent = useSelector((state: IReducer) => state.assembleiasAssessor.evento);
  const usuario = useSelector((state: IReducer) => state.auth.usuario);
  const dispatchAction = useDispatch();

  const initialValues = useMemo<any>(() => {
    const dataAtual = new Date();
    const momentDataFim: Moment =  moment(new Date().setMinutes(dataAtual.getMinutes() + 6));
    return {
      [ASSEMBLEIA_EDIT_MODAL_DATA_FIELD_ID]: momentDataFim ? momentDataFim.format('DD/MM/YYYY') : defaultValues[ASSEMBLEIA_EDIT_MODAL_DATA_FIELD_ID],
      [ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID]: momentDataFim ? momentDataFim.format('HH:mm') : defaultValues[ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID],
    }
  }, []);

  const mountData = (data:string, hora:string) => localeDateToISO(data) + 'T' + hora + ':00';

  const { register, handleSubmit, errors, formState, setValue } = useForm({
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: initialValues,
    criteriaMode: 'all',
  });

  const fieldsDisabled = useCallback((): boolean => {
    return salvando;
  }, [salvando]);

  const getError = useCallback(
    (fieldId: string): string | null => {
      return (formState.isSubmitted || formState.touched[fieldId]) && errors[fieldId] ? errors[fieldId].message : null;
    },
    [errors, formState]
  );

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  }, [dispatchAction, genericProps])
  
  const showError = (error: AxiosError<ErrorAPI>) => {
    setSalvando(false);
    ErrorHandler(error.response!.data);
  }

  const atualizarPautas = useCallback(() => {
    window.setTimeout(() => {
      dispatchAction(
        assembleiasAssessorActionsLoadPautas(
          currentEvent!.id,
          usuario!.cpfCnpj,
          () => {
            setSalvando(false);
            toClose();
          },
          showError
        )
      )
    }, 2000);
  }, [dispatchAction, currentEvent, usuario, toClose])

  // const getSeconds = useCallback((): number => {
  //   return tempo ? tempo.timeInSeconds : 0;
  // }, [tempo])

  const confirmar = handleSubmit((fields: any) => {
    setSalvando(true);
    dispatchAction(
      assembleiasAssessorActionsAlterarSituacaoPautaPorData(
        genericProps!.pauta.idPauta,
        mountData(fields[ASSEMBLEIA_EDIT_MODAL_DATA_FIELD_ID], fields[ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID]),
        AssembleiaPautaStatus.Liberada,
        atualizarPautas,
        showError
      )
    )
  });

  // const confirmarDisabled = useCallback((): boolean => {
  //   const tempoEmSegundos: number = getSeconds();
  //   if (typeof tempoEmSegundos === 'number' && tempoEmSegundos > 0) {
  //     return false;
  //   }
  //   return true;
  // }, [getSeconds]);

  return (
    <GenericModal
      title={ t("AbrirVotacaoPautaModal.title") }
      content={(
        <Grid
          container spacing={3}
        >
          {/* <Grid item xs={ 12 }>
            <InputTime
              className={ classes.inputTime }
              value={ tempo ? tempo!.timeStr : INITIAL_STATUS }
              onChange={ e => setTempo(e) }
              duration />
          </Grid> */}

          <Grid item xs={12} sm={6}>
            <TextField
              placeholder="dd/mm/aaaa"
              inputProps={{
                maxLength: 10
              }}
              onChange={inputDateMask(date => setValue(ASSEMBLEIA_EDIT_MODAL_DATA_FIELD_ID, date))}
              label={t(`AbrirVotacaoPautaModal.dataFim.label`)}
              name={"data"}
              className={classes.selectRoot}
              helperText={getError(ASSEMBLEIA_EDIT_MODAL_DATA_FIELD_ID)}
              error={getError(ASSEMBLEIA_EDIT_MODAL_DATA_FIELD_ID) ? true : false}
              disabled={fieldsDisabled()}
              inputRef={register({
                required: t(
                  `AbrirVotacaoPautaModal.dataFim.errors.required`
                ) as string,
                validate: {
                  isValid: value => {
                    return isAValidDate(localeDateToISO(value))
                      ? true
                      : (t(
                          `AbrirVotacaoPautaModal.dataFim.errors.isValid`
                        ) as string);
                  },
                },
              })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              placeholder="HH:MM"
              inputProps={{
                maxLength: 5
              }}
              onChange={inputTimeMask(date => setValue(ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID, date))}
              label={t(`AbrirVotacaoPautaModal.horarioFim.label`)}
              name={ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID}
              className={classes.selectRoot}
              helperText={getError(ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID)}
              error={getError(ASSEMBLEIA_EDIT_MODAL_HORARIO_FIELD_ID) ? true : false}
              disabled={fieldsDisabled()}
              inputRef={register({
                required: t(
                  `AbrirVotacaoPautaModal.horarioFim.errors.required`
                ) as string,
                validate: {
                  isValid: value => {
                    return isAValidTime(value)
                      ? true
                      : (t(
                          `AbrirVotacaoPautaModal.horarioFim.errors.isValid`
                        ) as string);
                  },
                },
              })}
            />
          </Grid>
          
          <Grid item xs={ 12 } className={ classes.actionsContent }>
            <Button
              variant="contained"
              color="primary"
              onClick={ confirmar }
              disabled={ salvando || !formState.isValid }
              endIcon={ salvando ? <SyncIcon className="animation-rotate" /> : null }
            >
              { t("AbrirVotacaoPautaModal.confirmarButton") }
            </Button>
          </Grid>
        </Grid>
      )}
      genericProps={{
        maxWidth: 'sm',
        onClose: !salvando ? toClose : undefined,
      }}
      />
  )
}